import type { ParticipantConfig } from "@cloudnest/stone-flicking-core-engine";
import { initMatch } from "@cloudnest/stone-flicking-core-engine";
import { DEFAULT_STONE_FLICKING_CONFIG } from "./data/default-config";
import type { PlayerId } from "./types/common";
import type { StoneFlickingConfig } from "./types/game-config";
import type { StoneFlickingState } from "./types/game-state";
import { buildCoreConfig } from "./utils/config-builder";
import { wrapCoreState } from "./utils/state-mapper";

const PLAYER_IDS: ReadonlyArray<PlayerId> = ["P1", "P2", "P3", "P4"];

const DEFAULT_PLAYER_NAMES: ReadonlyArray<string> = [
  "Player 1",
  "Player 2",
  "Player 3",
  "Player 4",
];

export interface InitGameOptions {
  readonly config?: StoneFlickingConfig;
  readonly playerNames?: ReadonlyArray<string>;
  readonly hostPlayerId?: string;
}

export function initGame(options: InitGameOptions = {}): StoneFlickingState {
  const { config = DEFAULT_STONE_FLICKING_CONFIG, playerNames } = options;

  const coreConfig = buildCoreConfig(config);

  const participantConfigs: ReadonlyArray<ParticipantConfig> = Array.from(
    { length: config.playerCount },
    (_, i) => ({
      id: PLAYER_IDS[i],
      name: playerNames?.[i] ?? DEFAULT_PLAYER_NAMES[i],
    }),
  );

  const coreState = initMatch({
    participantConfigs,
    config: coreConfig,
    initialEntities: config.deployment.seeds,
    hostPlayerId: options.hostPlayerId ?? PLAYER_IDS[0],
  });

  return wrapCoreState(coreState);
}
